export default "__VITE_ASSET__DvPvujU9__"